import React from 'react';
import { Section } from 'react-bulma-components';

const Steps = ({noOfSteps, active, setCurrentStep}) => {
  if(noOfSteps===1){
    return null;
  }
  const items = []
  for (let index = 1; index <= noOfSteps; index++) {
    let classname = "steps-segment" + (active === index ? " is-active" : "");
    items.push(<li className={classname} key={index}>
                <a className="steps-marker" onClick={() => setCurrentStep(index)}>{index}</a>
              </li>)
  }
return(
  <Section size="small">
    <ul className="steps is-horizontal">
      {items}
    </ul>
  </Section>
)
;}
export default Steps;